export const COLORS = {
	primary: "#1976d2",
	primaryLight: "#e3f0fd",
	primaryDark: "#0d47a1",
	success: "#19a24bff",
	successLight: "#ccf9dcff",
	successDark: "#168740ff",
	danger: "#dc2626",
	dangerLight: "#fee2e2",
	dangerDark: "#b91c1c",
	warning: "#f59e0b",
	warningLight: "#fef3c7",
	warningDark: "#d97706",
	info: "#3b82f6",
	infoLight: "#dbeafe",
	infoDark: "#1d4ed8",
	gray50: "#f9fafb",
	gray100: "#f3f4f6",
	gray200: "#e5e7eb",
	gray300: "#d1d5db",
	gray400: "#9ca3af",
	gray500: "#6b7280",
	gray600: "#4b5563",
	gray700: "#374151",
	gray800: "#1f2937",
	gray900: "#111827",
	background: "#f5f6fa",
	backgroundLight: "#f8fafd",
	white: "#ffffff",
	border: "#e0e0e0",
	borderLight: "#f0f0f0",
	borderDark: "#d1d5db",
}

export const TYPOGRAPHY = {
	fontFamily: '"Segoe UI", Thonburi, Tahoma, Geneva, Verdana, sans-serif',
	fontSize: {
		xs: "10px",
		sm: "12px",
		md: "14px",
		lg: "16px",
		xl: "18px",
		"2xl": "20px",
		"3xl": "24px",
	},
	fontWeight: {
		normal: 400,
		medium: 500,
		semibold: 600,
		bold: 700,
	},
	lineHeight: {
		tight: 1.25,
		normal: 1.5,
		relaxed: 1.75,
	},
}

export const SPACING = {
	xs: "4px",
	sm: "8px",
	md: "16px",
	lg: "24px",
	xl: "32px",
	"2xl": "48px",
}

export const BORDER_RADIUS = {
	sm: "4px",
	md: "6px",
	lg: "8px",
	xl: "12px",
	full: "9999px",
}

export const SHADOWS = {
	sm: "0 1px 3px rgba(0, 0, 0, 0.1)",
	md: "0 2px 8px rgba(0, 0, 0, 0.1)",
	lg: "0 4px 16px rgba(0, 0, 0, 0.1)",
	xl: "0 8px 32px rgba(0, 0, 0, 0.15)",
}
